import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Alert, Box, Button, Link, Paper, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Link as RouterLink, useParams } from 'react-router-dom';

import { getAssignedClients, getPeople } from '@/features/people/api/people';

export function AssignedClientsPage() {
  const technicianId = Number(useParams().personId);
  const people = useQuery({
    queryKey: ['people', 'technicians'],
    queryFn: () => getPeople('technicians'),
  });
  const assignments = useQuery({
    queryKey: ['technician-clients', technicianId],
    queryFn: () => getAssignedClients(technicianId),
    enabled: Number.isInteger(technicianId) && technicianId > 0,
  });
  const technician = people.data?.find((person) => person.id === technicianId);

  return (
    <Box sx={{ p: 1 }}>
      <Paper elevation={0} sx={paperSx}>
        <Button
          component={RouterLink}
          to="/technicians"
          startIcon={<ArrowBackIcon />}
          sx={commandButtonSx}
        >
          Back
        </Button>
      </Paper>
      <Paper elevation={0} sx={{ ...paperSx, mt: 1.5, p: 2.5 }}>
        <Typography variant="h1">Active clients for {technician?.name ?? 'Technician'}</Typography>
        <Typography color="text.secondary">Technician client assignments</Typography>
      </Paper>
      <Paper elevation={0} sx={{ ...paperSx, mt: 1.5, p: 2 }}>
        {(people.isError || assignments.isError) && (
          <Alert severity="error">Assigned clients could not be loaded.</Alert>
        )}
        {!assignments.isLoading && !assignments.data?.length && !assignments.isError && (
          <Alert severity="info">No active clients are assigned to this technician.</Alert>
        )}
        <Stack divider={<Box sx={{ borderBottom: '1px solid #edebe9' }} />}>
          {(assignments.data ?? []).map((assignment) => (
            <Box
              key={assignment.id}
              sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', py: 1.5 }}
            >
              <Link
                component={RouterLink}
                to={`/clients/${assignment.service_location.client.id}`}
                underline="always"
              >
                {assignment.service_location.client.name}
              </Link>
              <Link
                component={RouterLink}
                to={`/clients/${assignment.service_location.client.id}/service-locations/${assignment.service_location.id}`}
                underline="always"
              >
                {assignment.service_location.name}
              </Link>
            </Box>
          ))}
        </Stack>
        <Typography variant="body2" sx={{ pt: 1.5 }}>
          Rows: {assignments.data?.length ?? 0}
        </Typography>
      </Paper>
    </Box>
  );
}

const paperSx = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  boxShadow: '0 2px 6px rgba(0,0,0,.12)',
  minHeight: 44,
};
const commandButtonSx = {
  color: 'text.primary',
  '& .MuiButton-startIcon': { color: 'primary.main' },
};
